import api from '@/api/api.js'

export default {
    getRecapConsultation(data) {
        const promise = api.clinique().post('/produits-exploitation/consultation/recap', data)
        return promise.then((response) => response.data)
    },

    getListeRecapConsultation(data) {
        const promise = api.clinique().get('/produits-exploitation/consultation/'+data.categorie_id+'/est-paye/'+data.est_paye+'/type-period/'+data.type_period+'/period/'+data.period+'/liste')
        return promise.then((response) => response.data)
    },

    getListePatientByTypeConsultation(data) {
        const promise = api.clinique().get('/produits-exploitation/patients/'+data.tarif_id+'/est-paye/'+data.est_paye+'/type_period/'+data.type_period+'/period/'+data.period+'/liste')
        return promise.then((response) => response.data)
    },

    getRecapAnalyse(data) {
        const promise = api.clinique().get('/produits-exploitation/analyses/'+data.est_differe+'/type_period/'+data.type_period+'/period/'+data.period)
        return promise.then((response) => response.data)
    },

    getListeRecapAnalyse(data) {
        const promise = api.clinique().get('/produits-exploitation/analyses/'+data.est_differe+'/type_period/'+data.type_period+'/period/'+data.period+'/liste')
        return promise.then((response) => response.data)
    },

    getListePatientAnalyse(data) {
        const promise = api.clinique().get('/produits-exploitation/analyses/'+data.analyse_id+'/est-differe/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste/patients')
        return promise.then((response) => response.data)
    },

    getRecapExamen(data) {
        const promise = api.clinique().get('/produits-exploitation/examens/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period)
        return promise.then((response) => response.data)
    },

    getListeRecapExamen(data) {
        const promise = api.clinique().get('/produits-exploitation/examens/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste')
        return promise.then((response) => response.data)
    },

    getListePatientExamen(data) {
        const promise = api.clinique().get('/produits-exploitation/examens/'+data.type_examen_id+'/est-differe/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste/patients')
        return promise.then((response) => response.data)
    },

    getRecapArticle(data) {
        const promise = api.clinique().get('/produits-exploitation/type-article/'+data.type_article+'/injectable/'+data.est_injectable+'/article/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period)
        return promise.then((response) => response.data)
    },

    getListeRecapArticle(data) {
        const promise = api.clinique().get('/produits-exploitation/type-article/'+data.type_article+'/injectable/'+data.est_injectable+'/article/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste')
        return promise.then((response) => response.data)
    },

    getListePatientRecapArticle(data) {
        const promise = api.clinique().get('/produits-exploitation/article/'+data.article_id+'/est-differe/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste/patients')
        return promise.then((response) => response.data)
    },

    getRecapSoin(data) {
        const promise = api.clinique().get('/produits-exploitation/soins/est-differe/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period)
        return promise.then((response) => response.data)
    },

    getListeRecapSoin(data) {
        const promise = api.clinique().get('/produits-exploitation/soins/est-differe/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste')
        return promise.then((response) => response.data)
    },

    getListePatientRecapSoin(data) {
        const promise = api.clinique().get('/produits-exploitation/soins/'+data.soin_id+'/est-differe/'+data.est_differe+'/type-period/'+data.type_period+'/period/'+data.period+'/liste/patients')
        return promise.then((response) => response.data)
    },

    getRecapBonConsommable(data) {
        const promise = api.clinique().post('/produits-exploitation/bon-consommable/recap', data)
        return promise.then((response) => response.data)
    },

    getListeRecapBonConsommable(data) {
        const promise = api.comptabilite().post('/operations/produit-exploitation/bon-consommable/liste', data)
        return promise.then((response) => response.data)
    },

    getListePatientBonConsommable(data) {
        const promise = api.comptabilite().post('/operations/produit-exploitation/bon-consommable/liste/patients', data)
        return promise.then((response) => response.data)
    },

    getRecapAdmission(data) {
        const promise = api.clinique().post('/produits-exploitation/admission/recap', data)
        return promise.then((response) => response.data)
    },

    getListeRecapAdmission(data) {
        const promise = api.clinique().post('/produits-exploitation/admission/liste', data)
        return promise.then((response) => response.data)
    },

    getListePatientAdmission(data) {
        const promise = api.clinique().post('/produits-exploitation/admission/liste/patients', data)
        return promise.then((response) => response.data)
    },
}